/*
 * Converted to ts on 14/01/2020
 * See https://bitbucket.org/flowingly-team/flowingly-source-code/src/deaa3e49cef09006e53d6351564e8e4ba65c1f62/src/Flowingly.Shared.Angular/flowingly.filters/filters.module.js?at=master
 */
'use strict';
import angular from 'angular';

angular.module('flowingly.modeler.validation', ['flowingly.services']);
